export const isNotFound = (error) => error?.response?.status === 404;

export const asEmptyList = (error) => {
    if (!isNotFound(error)) {
        throw error;
    }
    return {
        TimeStamp: error.response?.data?.TimeStamp ?? null,
        Message: error.response?.data?.Message ?? "",
        Status: 404,
        Data: [],
    };
};

export const asEmptyPage = (error) => {
    if (!isNotFound(error)) {
        throw error;
    }
    return {
        TimeStamp: error.response?.data?.TimeStamp ?? null,
        Message: error.response?.data?.Message ?? "",
        Status: 404,
        Data: { content: [], totalElements: 0, totalPages: 0, currentPage: 0, pageSize: 20 },
    };
};

export const isHttpsUrl = (value) => {
    if (!value) {
        return true;
    }
    try {
        return new URL(value).protocol === "https:";
    } catch {
        return false;
    }
};

export const authHeaders = (token) => ({
    Authorization: `Bearer ${token}`,
});
